import { Link } from 'react-router-dom'

import styled from 'styled-components'

export const OrgsContainer = styled.div`
  padding: 5% 0;
`

export const OrgsHeader = styled.div`
  margin: 0 auto;
  max-width: 70%;
  padding-top: 2em;
  text-align: center;

  h2 {
    margin-bottom: 16px;
  }

  span {
    color: gray;
  }
`

export const OrgsWrapper = styled.div`
  margin: 1em;
`

export const OrgCard = styled(Link)`
  width: 400px;
  height: 100px;
  margin: 2em auto;
  padding: 10px 0 10px 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
`

export const OrgCardBrand = styled.img`
  width: 100px;
  max-height: 100px;
  border-radius: 15px;
`

export const OrgCardTitle = styled.h4`
  display: block;
  margin-left: 1em;
  color: #000000;
`
